import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { copyTextToClipboard } from '../../utils/copy';
import { useToasts } from '../common/Toast';
import { GlobalContext } from '../contexts/GlobalContext';
import { EventWithData } from '../../../../../typings/Event.interface';
import { Request } from '../../../../../typings/Request.interface';
import { APISource } from '../../../../../typings/Source.interface';
const useCopyAsCurl = props => {
  const $ = _c(11);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  if ("event" in props) {
    const {
      event
    } = props;
    let t0;
    if ($[0] !== HookdeckAPI || $[1] !== addToast || $[2] !== event?.data || $[3] !== event?.id) {
      t0 = async () => {
        const data = event?.data;
        const is_binary = data?.body_format === "binary";
        const raw_body_response = is_binary ? null : await HookdeckAPI.events.getRawBody(event?.id as string);
        const raw_body = raw_body_response instanceof Blob ? null : raw_body_response?.body;
        const curl_snippet_lines = [`curl "${data?.url}"`] as string[];
        curl_snippet_lines.push(`-X ${data?.method?.toUpperCase()}`);
        Object.entries(data?.headers ?? {}).forEach(t1 => {
          const [key, value] = t1;
          if (value != null) {
            curl_snippet_lines.push(`-H "${key}: ${value.replace(/"/g, "\\\"")}"`);
          }
        });
        if (is_binary) {
          curl_snippet_lines.push("--data-binary @payload.bin");
        } else {
          if (raw_body) {
            curl_snippet_lines.push(`-d "${raw_body.replace(/"/g, "\\\"")}"`);
          }
        }
        const curl_snippet = curl_snippet_lines.join(" \\\n");
        const success = await copyTextToClipboard(curl_snippet);
        if (success) {
          addToast("success", "Copied cURL command to clipboard");
        }
      };
      $[0] = HookdeckAPI;
      $[1] = addToast;
      $[2] = event?.data;
      $[3] = event?.id;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    return t0;
  }
  if ("request" in props) {
    const {
      request,
      source
    } = props;
    let t0;
    if ($[5] !== HookdeckAPI || $[6] !== addToast || $[7] !== request?.data || $[8] !== request?.id || $[9] !== source?.url) {
      t0 = async () => {
        const appendTrailingSlash = _temp;
        const data_0 = request?.data;
        const is_binary_0 = data_0?.body_format === "binary";
        const raw_body_response_0 = is_binary_0 ? null : await HookdeckAPI.requests.getRawBody(request?.id as string);
        const raw_body_0 = raw_body_response_0 instanceof Blob ? null : raw_body_response_0?.body;
        let url_0 = source?.url || "https://mock.hookdeck.com";
        if (data_0?.path) {
          url_0 = appendTrailingSlash(url_0, data_0.path);
        }
        if (data_0?.query) {
          url_0 = `${url_0}?${data_0?.query}`;
        }
        const curl_snippet_lines_0 = [`curl "${url_0}"`] as string[];
        curl_snippet_lines_0.push(`-X ${(data_0?.headers["x-hookdeck-original-method"] || "POST").toUpperCase()}`);
        Object.entries(data_0?.headers ?? {}).forEach(t1 => {
          const [key_0, value_0] = t1;
          if (value_0 != null) {
            curl_snippet_lines_0.push(`-H "${key_0}: ${value_0.replace(/"/g, "\\\"")}"`);
          }
        });
        if (is_binary_0) {
          curl_snippet_lines_0.push("--data-binary @payload.bin");
        } else {
          if (raw_body_0) {
            curl_snippet_lines_0.push(`-d "${raw_body_0.replace(/"/g, "\\\"")}"`);
          }
        }
        const curl_snippet_0 = curl_snippet_lines_0.join(" \\\n");
        const success_0 = await copyTextToClipboard(curl_snippet_0);
        if (success_0) {
          addToast("success", "Copied cURL command to clipboard");
        }
      };
      $[5] = HookdeckAPI;
      $[6] = addToast;
      $[7] = request?.data;
      $[8] = request?.id;
      $[9] = source?.url;
      $[10] = t0;
    } else {
      t0 = $[10];
    }
    return t0;
  }
};
export default useCopyAsCurl;
function _temp(url, path) {
  const parts = url.split("?");
  if (parts[0].endsWith("/")) {
    parts[0] = parts[0].slice(0, -1);
  }
  return `${parts[0]}${path}${parts.length > 1 ? parts[0] : ""}`;
}